__turbopack_context__.v({
  "card": "yEwQuW_card",
  "header": "yEwQuW_header",
  "headerTitle": "yEwQuW_headerTitle",
});
